import React, { ReactElement } from 'react';
import './detailTerminuList.scss';

interface Props<T> {
  list: Array<T>;
  propertyName?: string;
  renderItem?: (item: T) => ReactElement,
  renderKey?: (item: T) => string,
}

const DetailTerminuList = <T extends object>({
  list, propertyName,
  renderItem, renderKey,
} : Props<T>): ReactElement => {
  if (list.length === 1) {
    return (
      <>
        {propertyName && (
          list[0][propertyName]
        )}
        {renderItem && (
          renderItem(list[0])
        )}
      </>
    );
  }
  return (
    <ul className="detail-terminu-list-ul">
      {list.map(item => (
        <li key={renderKey(item)}>
          {propertyName && (
            item[propertyName]
          )}
          {renderItem && (
            renderItem(item)
          )}
        </li>
      ))}
    </ul>
  );
};

export default DetailTerminuList;
